var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"car-number-widget-container",style:(_vm.getContainerStyle)},_vm._l((8),function(item,index){return _c('p',{key:index,class:[_vm.options.theme, 'car-number-item'],style:(_vm.getStyle(index, _vm.current))},[_vm._v(" "+_vm._s(index == 7 ? '新能源' : '')+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }